export const locale = {
    lang: 'ar',
    data: {
        MOVE_CARDS: 'انقل البطاقات',
        SELECTION: 'اختيار',
        ACTIVITY: 'نشاط',
    }
};
